import React from 'react';
import {Link} from 'react-router-dom';
import DemoPlaceholder from './DemoPlaceholder';
import section from '../../styles/components/sections.module.css';
import styles from '../../styles/components/LeaderboardsSection.module.css';

const LeaderboardsSection: React.FC = () => {
  return (
    <section className={section.section}>
      <div className={section.container}>
        <h2 className={section.title}>Compete on Global Leaderboards</h2>
        <p className={section.subtitle}>Weekly resets and all-time rankings across every game mode.</p>

        <div className={styles.featureRow}>
          <div className={styles.featureText}>
            <h3 className={styles.featureTitle}>Weekly Rankings</h3>
            <p className={styles.featureDescription}>
              New competition every week. Scores reset so everyone gets a fresh chance to claim the top spot across every game mode and difficulty.
            </p>
            <Link to="/ranking" className={styles.featureLink}>View Weekly Rankings &rarr;</Link>
          </div>
          <div className={styles.featureDemo}>
            <DemoPlaceholder />
          </div>
        </div>

        <div className={`${styles.featureRow} ${styles.featureRowReverse}`}>
          <div className={styles.featureText}>
            <h3 className={styles.featureTitle}>Player Profiles</h3>
            <p className={styles.featureDescription}>
              Track your activity with heatmaps, connect social accounts, and see your ranking history across all categories.
            </p>
            <Link to="/ranking-global" className={styles.featureLink}>View Global Rankings &rarr;</Link>
          </div>
          <div className={styles.featureDemo}>
            <DemoPlaceholder />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeaderboardsSection;
